import fetch from '../config/fetch';
// import {
//     Indicator
// } from 'mint-ui';

export const login = (account, password, phone, validate, fingerId) => {
    return fetch(
        '/api/Passport/Login',
        {
            account,
            password,
            phone,
            validate,
            fingerId
        },
        true,
        'POST'
    );
};

export const register = (userName, password, phone, phoneCode, inviteCode, validate,isSpreadRegister, fingerId) => {
    return fetch(
        '/api/Passport/Register',
        {
            userName, password, phone, phoneCode, inviteCode, validate, isSpreadRegister, fingerId
        },
        true,
        'POST'
    );
};

export const queryGames = () => {
    return fetch(
        '/api/Game/QueryGames',
        {},
        true,
        'GET'
    );
};

export const queryGamesIe = () => {
    return fetch(
        '/api/Game/QueryGamesIe',
        {},
        true,
        'GET'
    );
};

export const queryHotSlotGameListIe = () => {
    return fetch(
        '/api/Game/QueryHotSlotGameListIe',
        {},
        true,
        'GET'
    );
};


export const queryDetails = () => {
    return fetch(
        '/api/User/CheckUserData',
        {},
        false,
        'GET'
    );
};

export const queryGameBalanceByGame = (game) => {
    return fetch(
        '/api/User/QueryGameBalanceByGame/' + game,
        {},
        false,
        'GET'
    );
};

export const queryGameBalanceAll = () => {
    return fetch(
        '/api/User/QueryGameBalanceAll',
        {},
        false,
        'GET'
    );
};


export const transferByGame = (amount, game, direction) => {
    return fetch(
        '/api/User/TransferByGame',
        { amount, game, direction },
        true,
        'POST'
    );
};

export const transferReceiveAll = () => {
    return fetch(
        '/api/User/TransferReceiveAll',
        {},
        true,
        'POST'
    );
};

export const gameLogin = (game, balanceIn, code, gameLane, gameId) => {
    return fetch(
        '/api/Game/GameLogin',
        { game, balanceIn, code, gameLane, gameId },
        true,
        'POST'
    );
};

export const gameLoginById = (id, Plat) => {
    return fetch(
        '/api/Game/GameLoginById',
        { id, Plat },
        true,
        'POST'
    );
};

export const qeuryMessageCount = () => {
    return fetch(
        '/api/User/QeuryMessageCount',
        {},
        false,
        'GET'
    );
};

export const queryServiceLines = () => {
    return fetch(
        '/api/Home/QueryServiceLines',
        {},
        false,
        'GET'
    );
};

export const queryNotice = () => {
    return fetch(
        '/api/Home/QueryNotice',
        {},
        false,
        'GET'
    );
};


export const queryPromos = (type) => {
    return fetch(
        '/api/Promotion/QueryPromos/' + type,
        {},
        false,
        'GET'
    );
};

export const queryPromosIe = (type) => {
    return fetch(
        '/api/Promotion/QueryPromosIe/' + type,
        {},
        false,
        'GET'
    );
};

export const queryPromosById = (id) => {
    return fetch(
        '/api/Promotion/QueryPromosById/' + id,
        {},
        true,
        'GET'
    );
};

export const queryNoticePage = (pageIndex, type) => {
    return fetch(
        '/api/Home/QueryNoticePage',
        { pageIndex, type },
        true,
        'GET'
    );
};

export const querySiteChat = (pageIndex) => {
    return fetch(
        '/api/User/QuerySiteChat/' + pageIndex,
        {},
        true,
        'GET'
    );
};

export const readMessage = () => {
    return fetch(
        '/api/User/ReadMessage',
        {},
        false,
        'GET'
    );
};


export const sendMessageForNotLogin = (userName, phone, type) => {
    return fetch(
        '/api/Home/SendMessageForNotLogin',
        { userName, phone, type },
        true,
        'POST'
    );
};

export const sendMessageForLogin = (type) => {
    return fetch(
        '/api/Home/SendMessageForLogin/' + type,
        {},
        true,
        'POST'
    );
};

export const checkUserName = (userName) => {
    return fetch(
        '/api/User/CheckUserName/' + userName,
        {},
        false,
        'GET'
    );
}

export const queryHongbaoYu = () => {
    return fetch(
        '/api/Promotion/QueryHongbaoYu',
        {},
        false,
        'GET'
    )
}
export const grabHongbao = () => {
    return fetch(
        '/api/Promotion/GrabHongbao',
        {},
        true,
        'POST'
    )
}

export const updateDetails = (realName, sex, birthday, phone, email, qq, fb) => {
    return fetch(
        '/api/User/UpdateDetails',
        { realName, sex, birthday, phone, email, qq, fb },
        true,
        'POST'
    )
}

export const updatePassword = (oldPassword, newPassword) => {
    return fetch(
        '/api/User/UpdatePassword',
        { oldPassword, newPassword },
        true,
        'POST'
    )
}

export const queryPayList = () => {
    return fetch(
        '/api/Finance/QueryPayList',
        {},
        true,
        'GET'
    )
}

export const requestPay = (amount, name, channel, bank, promo) => {
    return fetch(
        '/api/Finance/RequestPay',
        { amount, name, channel, bank, promo },
        true,
        'POST'
    )
}

export const needToPayFee = (id) => {
    return fetch(
        '/api/Finance/NeedToPayFee/' + id,
        {},
        false,
        'POST'
    )
}

export const queryWithdraw = () => {
    return fetch(
        '/api/Finance/QueryWithdraw',
        {},
        true,
        'GET'
    )
}

export const queryFastWithdrawTimeRange = () => {
    return fetch(
        '/api/Finance/QueryFastWithdrawTimeRange',
        {},
        true,
        'GET'
    )
}

export const requestWithdraw = (amount, password, cardNo, bank, wid) => {
    return fetch(
        '/api/Finance/RequestWithdraw',
        { amount, password, cardNo, bank, wid },
        true,
        'POST'
    )
}

export const requestWithdrawNew = (amount, password, cardNo, bank, wid, pid) => {
    return fetch(
        '/api/Finance/requestWithdrawNew',
        { amount, password, cardNo, bank, wid, pid },
        true,
        'POST'
    )
}

export const fixedAmountWRecordDetails = () => {
    return fetch(
        '/api/Finance/FixedAmountWRecordDetails',
        { },
        false,
        'GET'
    )
}

export const fixedAmountWRecordByOrderno = (orderNo) => {
    return fetch(
        '/api/Finance/FixedAmountWRecordByOrderno/'+ orderNo,
        { },
        true,
        'GET'
    )
}

export const conformedFixedAmountWDPromo = (orderNo) => {
    return fetch(
        '/api/Promotion/ConformedFixedAmountWDPromo/'+orderNo,
        { },
        true,
        'POST'
    )
}

export const addCard = (bankId, cardNo, bankAddress, verifyCode, images, bindType) => {
    return fetch(
        '/api/Finance/AddCard',
        { bankId, cardNo, bankAddress, verifyCode, images, bindType },
        true,
        'POST'
    )
}

export const updateGameSort = (gameTypes) => {
    return fetch(
        '/api/Game/UpdateGameSort',
        { gameTypes },
        false,
        'POST'
    )
}


export const querySlotGameById = (id) => {
    return fetch(
        '/api/Game/querySlotGameById/'+ id,
        {},
        true,
        'GET'
    )
}

export const queryRecordDetails = (type, timeType, state, pageIndex, noLoading) => {
    return fetch(
        '/api/Order/QueryRecordDetails',
        { type, timeType, state, pageIndex },
        noLoading?false:true,
        'GET'
    )
}

export const upload = (type, title, content, images) => {
    return fetch(
        '/api/Home/Upload',
        { type, title, content, images },
        true,
        'POST'
    )
}

export const uploadDeposit = (orderNo, images) => {
    return fetch(
        '/api/Finance/UploadDeposit',
        { orderNo, images },
        true,
        'POST'
    )
}

export const queryRecordTotal = (startTime, stopTime) => {
    return fetch(
        '/api/Order/QueryRecordTotal',
        { startTime, stopTime },
        true,
        'GET'
    )
}


export const queryRecordsByGame = (pageIndex, startTime, stopTime, gameId) => {
    return fetch(
        '/api/Order/QueryRecordsByGame',
        { pageIndex, startTime, stopTime, gameId },
        true,
        'GET'
    )
}


export const queryGameGroup = () => {
    return fetch(
        '/api/Game/QueryGameGroup',
        {},
        true,
        'GET'
    )
}

export const queryPromoSelfList = () => {
    return fetch(
        '/api/Promotion/QueryPromoSelfList',
        {},
        true,
        'GET'
    )
}

export const queryBetOrder = (gameId) => {
    return fetch(
        '/api/Promotion/QueryBetOrder/' + gameId,
        {},
        true,
        'GET'
    )
}


export const insertPromoSelf = (promoCode, remarks, sValue) => {
    return fetch(
        '/api/Promotion/InsertPromoSelf',
        {
            promoCode,
            remarks,
            sValue,
        },
        true,
        'POST'
    );
};

export const queryBetAmount = () => {
    return fetch('/api/Promotion/QueryBetAmount', {}, true, 'GET');
};

export const queryWeeklyBetPromo = () => {
    return fetch('/api/Promotion/QueryWeeklyBetPromo', {}, false, 'GET');
};

export const appWeeklyBetPromo = () => {
    return fetch('/api/Promotion/appWeeklyBetPromo', {}, true, 'POST');
};

export const queryInviteData = () => {
    return fetch(
        '/api/Promotion/QueryInviteData',
        {},
        true,
        'GET'
    );
};


export const queryInviteList = (pageIndex, startTime, stopTime) => {
    return fetch(
        '/api/Promotion/QueryInviteList',
        { pageIndex, startTime, stopTime },
        true,
        'GET'
    );
};

export const queryInviteBonusList = (pageIndex) => {
    return fetch(
        '/api/Promotion/QueryInviteBonusList/' + pageIndex,
        {},
        true,
        'GET'
    );
};


export const queryWeekChallenge = () => {
    return fetch(
        '/api/Promotion/QueryWeekChallenge',
        {},
        true,
        'GET'
    );
};


export const queryAttendance = () => {
    return fetch(
        '/api/Promotion/QueryAttendance',
        {},
        true,
        'GET'
    );
};

export const attendance = () => {
    return fetch(
        '/api/Promotion/Attendance',
        {},
        true,
        'POST'
    );
};

export const requestWeek = (amount) => {
    return fetch(
        '/api/Promotion/RequestWeek/' + amount,
        {},
        true,
        'POST'
    );
};

export const unlockWeek = () => {
    return fetch(
        '/api/Promotion/UnlockWeek',
        {},
        true,
        'POST'
    );
};

export const signupAgent = (password, code, phone, email, qq, up, fingerId) => {
    return fetch(
        '/api/Passport/SignupAgent',
        { password, code, phone, email, qq, up, fingerId },
        true,
        'POST'
    );
};

export const checkPhone = (userName, phone) => {
    return fetch(
        '/api/User/CheckPhone',
        { userName, phone },
        true,
        'POST'
    );
};

export const resetPassword = (userName, phone, phoneCode, password) => {
    return fetch(
        '/api/User/ResetPassword',
        { userName, phone, phoneCode, password },
        true,
        'POST'
    );
};

export const queryPopTips = () => {
    return fetch(
        '/api/Home/QueryPopTips',
        {},
        true,
        'GET'
    )
}

export const querySelfBonusReport = () => {
    return fetch(
        '/api/Promotion/QuerySelfBonusReport',
        {},
        true,
        'GET'
    )
}

export const querySelfBonusRecoords = (status, pageIndex) => {
    return fetch(
        '/api/Promotion/QuerySelfBonusRecoords',
        {status, pageIndex},
        true,
        'GET'
    )
}

export const appSelfBonus = (pid) => {
    return fetch(
        '/api/Promotion/AppSelfBonus/' + pid,
        {},
        true,
        'POST'
    )
}


export const queryAppData = () => {
    return fetch(
        '/api/Home/QueryAppData',
        {},
        true,
        'GET'
    );
};


export const queryDepositAmount = () => {
    return fetch(
        '/api/User/QueryDepositAmount',
        {},
        true,
        'GET'
    );
};


export const qeuryFixDepositPromo = (id) => {
    return fetch(
        '/api/Finance/QeuryFixDepositPromo/' + id,
        {},
        true,
        'GET'
    );
};

export const deleteCard = (cardNo) => {
    return fetch(
        '/api/Finance/DeleteCard/'+cardNo,
        { },
        true,
        'POST'
    )
}


export const qeuryVipDetails = () => {
    return fetch(
        '/api/Home/QeuryVipDetails',
        {},
        true,
        'GET'
    );
};

export const updateMemberIcon = (img,currencyType) => {
    return fetch(
        '/api/User/UpdateMemberIcon',
        {img,currencyType},
        true,
        'POST'
    );
};

export const queryAllSlotGameList = () => {
    return fetch(
        '/api/Game/QueryAllSlotGameList',
        {},
        true,
        'GET'
    );
};

export const queryAgentPublicData = () => {
    return fetch(
        '/api/Home/QueryAgentPublicData',
        {},
        true,
        'GET'
    );
};

export const qeuryRefVipRates = () => {
    return fetch(
        '/api/User/QeuryRefVipRates',
        {},
        true,
        'GET'
    );
};

export const qeuryYestodayReferralReport = () => {
    return fetch(
        '/api/User/QeuryYestodayReferralReport',
        {},
        true,
        'GET'
    );
};

export const qeuryReferralReportHistory = () => {
    return fetch(
        '/api/User/QeuryReferralReportHistory',
        {},
        true,
        'GET'
    );
};

export const qeuryWeekCommision = () => {
    return fetch(
        '/api/User/QeuryWeekCommision',
        {},
        true,
        'GET'
    );
};

export const qeuryReferralWaggered = (dateType, dataType) => {
    return fetch(
        '/api/User/QeuryReferralWaggered',
        {dateType, dataType},
        true,
        'POST'
    );
};

export const qeuryReferralPlayesData = (dateType, dataType, pageIndex) => {
    return fetch(
        '/api/User/QeuryReferralPlayesData',
        { dateType, dataType, pageIndex },
        true,
        'POST'
    );
};


export const queryAccountReportIntl = () => {
    return fetch(
        '/api/User/QueryAccountReportIntl',
        { },
        false,
        'GET'
    );
};


export const queryPaymentsByUid = (uid) => {
    return fetch(
        '/api/Order/QueryPaymentsByUid/'+ uid,
        { },
        false,
        'GET'
    );
};


export const updatePaymentByOrderId = (id) => {
    return fetch(
        '/api/Order/UpdatePaymentByOrderId/'+ id,
        { },
        false,
        'POST'
    );
};

export const qeuryHotSlotGameListVINR = () => {
    return fetch(
        '/api/Game/QeuryHotSlotGameListVINR',
        { },
        true,
        'GET'
    );
};

export const qeuryHotSlotGameListVVINR = () => {
    return fetch(
        '/api/Game/QeuryHotSlotGameListVVINR',
        { },
        true,
        'GET'
    );
};


export const qeuryAllGameListByGameType = (gameType) => {
    return fetch(
        '/api/Game/QeuryAllGameListByGameType/'+gameType,
        { },
        true,
        'GET'
    );
};

export const qeuryFavoriteGames = () => {
    return fetch(
        '/api/Game/QeuryFavoriteGames',
        { },
        false,
        'GET'
    );
};


export const addToFavoriteGame = (id) => {
    return fetch(
        '/api/Game/AddToFavoriteGame/'+id,
        { },
        false,
        'POST'
    );
};


export const deleteFromFavoriteGame = (id) => {
    return fetch(
        '/api/Game/DeleteFromFavoriteGame/'+id,
        { },
        false,
        'POST'
    );
};

export const qeurySlotGameList = (plat) => {
    return fetch(
        '/api/Game/QeurySlotGameList/'+plat,
        { },
        true,
        'GET'
    );
};


export const qeuryPlayers = (dateType, pageIndex) => {
    return fetch(
        '/api/User/QeuryPlayers',
        { dateType, pageIndex },
        true,
        'POST'
    );
};


// export const agentBillRecords =(dateStatus,pageIndex)=>{
//     return fetch(
//         '/api/User/agentBillRecords',
//         { dateStatus, pageIndex },
//         true,
//         'POST'
//     );
// }

export const downloadApp = () => {
    return fetch(
        '/api/Promotion/DownloadApp',
        { },
        true,
        'POST'
    );
};

export const firstDepositBonus = () => {
    return fetch(
        '/api/Promotion/FirstDepositBonus',
        { },
        true,
        'POST'
    );
};

export const firstUsdtDepositBonus = () => {
    return fetch(
        '/api/Promotion/FirstUsdtDepositBonus',
        { },
        true,
        'POST'
    );
};

export const referralFirstActivePlayerBonus = () => {
    return fetch(
        '/api/Promotion/ReferralFirstActivePlayerBonus',
        { },
        true,
        'POST'
    );
};

export const appWeeklyBonus = () => {
    return fetch(
        '/api/Promotion/AppWeeklyBonus',
        { },
        true,
        'POST'
    );
};

export const firstDepositWeeklyBonus = () => {
    return fetch(
        '/api/Promotion/FirstDepositWeeklyBonus',
        { },
        true,
        'POST'
    );
};

export const postTask = (path,taskId) => {
    return fetch(
        '/api/Promotion/PostTask?path='+ path+"&taskId="+taskId,
        {  },
        true,
        'POST'
    );
};


export const agentLogin = (token) => {
    return fetch(
        '/api/Passport/AgentLogin/'+token,
        { },
        true,
        'POST'
    );
};

export const recordDetails = (pageIndex, recordType, recordStatus, recordTime, account) => {
    return fetch(
        '/api/AgentBayo/RecordDetails',
        { pageIndex, recordType, recordStatus, recordTime, account },
        true,
        'POST'
    );
};

export const agentBillRecords = (pageIndex, dateStatus) => {
    return fetch(
        '/api/AgentBayo/AgentBillRecords',
        { pageIndex, dateStatus },
        true,
        'POST'
    );
};


export const playersFinanceReportListINR = (pageIndex, dateType) => {
    return fetch(
        '/api/AgentBayo/PlayersFinanceReportListINR',
        { pageIndex, dateType },
        true,
        'POST'
    );
};

export const queryAgentMonthlyReportData = () => {
    return fetch(
        '/api/AgentBayo/QueryAgentMonthlyReportData',
        { },
        true,
        'GET'
    );
};

export const queryAgentMonthlyCommission = () => {
    return fetch(
        '/api/AgentBayo/QueryAgentMonthlyCommission',
        { },
        true,
        'GET'
    );
};

export const queryAgentBillRulesINR = () => {
    return fetch(
        '/api/AgentBayo/QueryAgentBillRulesINR',
        { },
        true,
        'GET'
    );
};

export const agentTransferMoneyToSelf = (amount) => {
    return fetch(
        '/api/AgentBayo/AgentTransferMoneyToSelf/' + amount,
        { },
        true,
        'POST'
    );
};

export const refreshLoginD = () => {
    return fetch(
        '/api/Agent/RefreshLoginD',
        { },
        false,
        'GET'
    );
};


export const agentFirstDepositRecords = (pageIndex, recordTime) => {
    return fetch(
        '/api/AgentBayo/AgentFirstDepositRecords',
        { pageIndex, recordTime },
        true,
        'POST'
    );
};

export const agentRegisterRecords = (pageIndex, recordTime) => {
    return fetch(
        '/api/AgentBayo/AgentRegisterRecords',
        { pageIndex, recordTime },
        true,
        'POST'
    );
};

export const queryAgentReportData = (recordTime) => {
    return fetch(
        '/api/AgentBayo/QueryAgentReportData/'+ recordTime,
        {},
        true,
        'GET'
    );
};

export const betReportRequest = () => {
    return fetch(
        '/api/Finance/BetReportRequest',
        {},
        false,
        'GET'
    );
};

export const queryGameList = () => {
    return fetch(
        '/api/Game/queryGameList',
        {},
        true,
        'GET'
    );
};

export const queryOrderListByGame = (pageIndex,gameId,dateType,settled) => {
    return fetch(
        '/api/Game/queryOrderListByGame',
        {pageIndex,gameId,dateType,settled},
        true,
        'GET'
    );
};

export const queryTaskCategoryUI_INR = () => {
    return fetch(
        '/api/Promotion/QueryTaskCategoryUI_INR',
        {},
        true,
        'GET'
    );
};

export const loadFixPosPromoEntiy_INR = () => {
    return fetch(
        '/api/Promotion/LoadFixPosPromoEntiy_INR',
        {},
        true,
        'GET'
    );
};

/** PG 电游优惠页：救援金 / 注单挑战 / 每日流水 UI 数据（网关转发 AWCP） */
export const queryPGDailyRescuePromoUI = () => {
    return fetch(
        '/api/Promotion/QueryPGDailyRescuePromoUI',
        {},
        true,
        'GET'
    );
};

/** EWC 电竞世界杯：救援金 UI */
export const queryEWCESRescuePromoUI = () => {
    return fetch(
        '/api/Promotion/QueryEWCESRescuePromoUI',
        {},
        true,
        'GET'
    );
};

export const queryPGDailyOrderPromoUI = () => {
    return fetch(
        '/api/Promotion/QueryPGDailyOrderPromoUI',
        {},
        true,
        'GET'
    );
};

export const queryPGDailyBetPromoUI = () => {
    return fetch(
        '/api/Promotion/QueryPGDailyBetPromoUI',
        {},
        true,
        'GET'
    );
};

/** PG 电游优惠申请（网关 ApplicationPGPromo → AWCP，body 含 DefaultParams + promoCode） */
export const applicationPGPromo = (promoCode) => {
    return fetch(
        '/api/Promotion/ApplicationPGPromo/' + promoCode,
        {},
        true,
        'POST'
    );
};

/** PG/EWC 优惠领取记录（网关 ApplicationPGPromoRecord → AWCP）recordType: 0=PG 1=EWC */
export const applicationPGPromoRecord = (timeType, status, recordType = 0) => {
    return fetch(
        '/api/Promotion/ApplicationPGPromoRecord',
        { timeType, status, recordType },
        true,
        'GET'
    );
};


export const agentQueryPlayerBalanceIntl = (account) => {
    return fetch(
        '/api/AgentBayo/AgentQueryPlayerBalanceIntl/'+account,
        {},
        false,
        'GET'
    );
};

export const queryAgentWallet = () => {
    return fetch(
        '/api/AgentBayo/QueryAgentWallet',
        {},
        true,
        'GET'
    );
};

export const agentWithdrawV1_S = (amount,cardno,password) => {
    return fetch(
        '/api/AgentBayo/AgentWithdrawV1_S',
        {amount,cardno,password},
        true,
        'POST'
    );
};

export const qeuryUISettingForWithdrawV1 = () => {
    return fetch(
        '/api/AgentBayo/QeuryUISettingForWithdrawV1',
        {},
        true,
        'GET'
    );
};

export const agentWithdrawRecords = (pageIndex,startTime,endTime) => {
    return fetch(
        '/api/AgentBayo/AgentWithdrawRecords',
        {pageIndex,startTime,endTime},
        true,
        'POST'
    );
};

export const queryPGLuckyOrderPromoUI_V = () => {
    return fetch(
        '/api/Promotion/QueryPGLuckyOrderPromoUI_V',
        {},
        true,
        'GET'
    );
};

export const queryPGTaskLevelPromoUI_V = () => {
    return fetch(
        '/api/Promotion/QueryPGTaskLevelPromoUI_V',
        {},
        true,
        'GET'
    );
};

export const queryPGHighOddsOrdersPromoUI_V = () => {
    return fetch(
        '/api/Promotion/QueryPGHighOddsOrdersPromoUI_V',
        {},
        true,
        'GET'
    );
};

export const dailyBonus = () => {
    return fetch('/api/Promotion/DailyBonusIntlV', {}, true, 'GET');
};

export const appDailyBonus = () => {
    return fetch('/api/Promotion/AppDailyBonusIntlV', {}, false, 'POST');
};

/** EWC 电竞轮盘：抽奖次数 */
export const queryEWCDailyBonusV = () => {
    return fetch('/api/Promotion/QueryEWCDailyBonusV', {}, true, 'GET');
};

/** EWC 电竞轮盘：抽奖申请 */
export const ewcAppDailyBonusV = () => {
    return fetch('/api/Promotion/EWCAppDailyBonusV', {}, false, 'POST');
};